export const circleLabel = (name) => (name === 'ダンスエクササイズ' ? 'ダンス\nエクササイズ' : name);
